import { css } from 'styled-components';
export const Scrollable = css`
  --scrollbar-size: 6px;
  /* For scroll */
  overflow: auto;
  scroll-padding: var(--scrollbar-size);
  scroll-margin: var(--scrollbar-size);

  & > ::-webkit-scrollbar {
    width: var(--scrollbar-size);
  }

  & > ::-webkit-scrollbar-thumb {
    border-radius: var(--border-radius-curved);
    background: var(--gray-20);
  }

  & > ::-webkit-scrollbar-track {
    background: var(--gray-10);
  }

  & > ::-webkit-scrollbar:horizontal {
    height: var(--scrollbar-size);
  }
`;
